var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "eu-pb_6" },
    [
      _c(
        "div",
        { staticClass: "eu-pb_3 eu-display_flex eu-align-items_center" },
        [
          _c("p", { staticClass: "emd-text _size_subpage eu-mr_2" }, [
            _vm._v(" " + _vm._s(_vm.sectionName) + " "),
          ]),
          _vm.status
            ? _c("emd-badge", {
                attrs: { text: _vm.status.text, color: _vm.status.color },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("data-display-table", { attrs: { tableData: _vm.tableData } }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }